<template>
  <div>
    <h1>ログインに失敗しました</h1>
    {{tmp}}
  </div>
</template>
<script>
export default {
  name: "Fail",
  data() {
    return {
      tmp: ""
    };
  },
  mounted() {
    this.tmp = this.$cookies.get("session");
  },
  methods: {}
};
</script>
<style scoped>
</style>